export const euro = (v: number | string | undefined | null): string => {
  const n = typeof v === 'string' ? parseFloat(v) : v ?? 0;
  return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(
    Number.isFinite(n as number) ? (n as number) : 0
  );
};

export const dateFmt = (v: string | undefined | null): string => {
  if (!v) return '';
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? v : d.toLocaleDateString('fr-FR');
};
